import {
  BaseReducerState,
  ItemCategory,
  DeleteCategoryAPIResponse,
} from '../../../services'
import { ActionTypes } from '../actions'

export type DeleteCategoryState = BaseReducerState & {
  data: ItemCategory | null
}

export const initialState: DeleteCategoryState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const deleteCategory = (
  state: DeleteCategoryState = initialState,
  action: { type: string; res: any }
): DeleteCategoryState => {
  switch (action.type) {
    case `${ActionTypes.DELETE_CATEGORY}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.DELETE_CATEGORY}_SUCCESS`: {
      const { success, data, message } = <DeleteCategoryAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
      }
    }
    case `${ActionTypes.DELETE_CATEGORY}_FAILURE`:
      const res = <DeleteCategoryAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.DELETE_CATEGORY}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
